/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


document.addEventListener("DOMContentLoaded", function(){

  productDescToggle();
  productAdditionalDetailes();
  //updateNotifyMeForm();
  shopCategoriesSectionTab();
  whySolidGoldSection();
  productMainReviewWidget();
  
});


function rechargeSubscriptionWidget(){
  const widgetContainer = document.querySelector('[data-widget-container]');
  if(!widgetContainer) return;

  const inputOption = widgetContainer.querySelectorAll(`input[name="selling_plan_select"]`);
  let sellingPlanInput = document.querySelectorAll('form input[name="selling_plan"]');
  if(inputOption.length){
    
    //on subscription input changed
    inputOption.forEach(input => {
      input.addEventListener('change',function(e){
        e.preventDefault();
        inputOption.forEach(el => el.closest('.rc_widget__option').classList.remove('rc-option--active'));
        e.target.closest('.rc_widget__option').classList.add('rc-option--active');
        let currentOption = e.target.value;
        if(currentOption == 'onetime'){
          if(sellingPlanInput.length){
            sellingPlanInput.forEach(ele => ele.value = '');
            if(widgetContainer.querySelector(`.rc__select`)){
              widgetContainer.querySelector(`.rc__select`).classList.remove('active');
            }
            if(widgetContainer.querySelector(`.rc-tab-content`)){
              widgetContainer.querySelector(`.rc-tab-content`).classList.remove('active');
            }
          }
        }else{
          if(sellingPlanInput.length){
            let selectedSeelingPlanId = widgetContainer.querySelector('.styledSelect').dataset.sellingId;
            sellingPlanInput.forEach(ele => ele.value = Number(selectedSeelingPlanId));
            if(widgetContainer.querySelector(`.rc-tab-content`)){
              widgetContainer.querySelector(`.rc-tab-content`).classList.add('active');
            }
          }
        }
      });
    });

    //on style select dropdown click
    const selectDropdown = widgetContainer.querySelector(`.styledSelect`);
    if(selectDropdown){
      selectDropdown.addEventListener('click',(e) => {
        e.preventDefault();
        if(e.target.closest(`.rc__select`)){
          e.target.closest(`.rc__select`).classList.toggle('active');
        }
      });
    }

    //on list item clicked
    const dropdownListItem = widgetContainer.querySelectorAll(`.rc__select .options li`);
    if(dropdownListItem.length){
      dropdownListItem.forEach(list => {
        list.addEventListener('click',(li) => {
          li.preventDefault();
          let seletedListValue = li.target.getAttribute('value');
          let seletedListName = li.target.textContent;
          if(selectDropdown){
            selectDropdown.textContent = seletedListName;
            selectDropdown.dataset.sellingId = seletedListValue;
            if(sellingPlanInput.length){
              sellingPlanInput.forEach(ele => ele.value = Number(seletedListValue));
            }
            if(widgetContainer.querySelector(`.rc__select`)){
              widgetContainer.querySelector(`.rc__select`).classList.remove('active');
            }
          }
        });
      });
    }

    //outside click close list dropdown
    document.onclick = function(e){
      if(!e.target.classList.contains('styledSelect')){
        if(widgetContainer.querySelector(`.rc__select`)){
          widgetContainer.querySelector(`.rc__select`).classList.remove('active');
        }
      }
    };
    
  }
}

function productDescToggle() {
  var maxL = 220; // description character limit..

  var contents = document.querySelector('.product-form__description');
  if(!contents) return;
  var text = contents.textContent;
  if (text.length > maxL) {
    var begin = text.substr(0, maxL);
    var end = text.substr(maxL);
  
    contents.innerHTML = `<div class="stripped--desc"><p>${begin}...</p></div>`;
  
    var hiddenDiv = document.createElement('div');
    hiddenDiv.className = 'none-stripped--desc';
    hiddenDiv.setAttribute('hidden', '');
    hiddenDiv.innerHTML = `<p>${text}</p>`;

    var readMoreLink = document.createElement('a');
    readMoreLink.className = 'readmore-desc';
    readMoreLink.href = '#';
    readMoreLink.textContent = 'Read More';
  
    contents.appendChild(hiddenDiv);
    contents.appendChild(readMoreLink);

    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('readmore-desc')) {
        event.preventDefault();
        var hiddenContent = event.target.closest('.product-form__description').querySelector('.none-stripped--desc');
        var visibleDiv = event.target.closest('.product-form__description').querySelector('.stripped--desc');
        if (hiddenContent) {
          if (hiddenContent.getAttribute('hidden') == '') {
            hiddenDiv.removeAttribute('hidden');
            if(visibleDiv) visibleDiv.setAttribute('hidden','');
            event.target.textContent = `Read Less`;
          } else {
            hiddenDiv.setAttribute('hidden','');
            if(visibleDiv) visibleDiv.removeAttribute('hidden');
            event.target.textContent = `Read More`;
          }
        }
      }
    });
    
  }
    
}

function productAdditionalDetailes() {
  const tabBtn = document.querySelector('[data-prod-additional-details]');
  const tabContent = document.querySelector('[data-additional-details-content]');
  if(!tabBtn) return;
  const tabList = tabBtn.querySelectorAll('[data-tab]');
  const tabListData = tabContent?.querySelectorAll('.tab--data');
  if(tabList.length){
    for(let i=0; i<tabList.length; i++){
      if(tabList[i]){
        tabList[i].addEventListener('click',function(e) {
          e.preventDefault();
          let currentAttr = e.target.dataset.tab;
          tabList.forEach(el => el.classList.remove('active'));
          e.target.classList.add('active');
          if(tabListData.length){
            tabListData.forEach(el => el.classList.remove('active'));
            tabContent.querySelector(`[id="${currentAttr}"]`).classList.add('active'); 
          }
        });
      }
    }
  }
}

function shopCategoriesSectionTab() {
  const tabBtn = document.querySelectorAll('.shop-categories [data-tab-title]');
  const tabContent = document.querySelectorAll('.shop-categories [data-tab]');
  if(!tabBtn.length) return;

  tabBtn.forEach(tab => {
    tab.addEventListener('click',function(e){
      e.preventDefault();
      let currentTabTitle = e.target.dataset.tabTitle;

      for(let i=0; i<tabBtn.length; i++){
        if(tabBtn[i]){
          tabBtn[i].classList.remove('active');
        }
        if(tabContent[i]){
          tabContent[i].classList.remove('active')
        }
      }
      e.target.classList.add('active');
      if(e.target.closest('.shop-categories').querySelector(`[data-tab="${currentTabTitle}"]`)){
        e.target.closest('.shop-categories').querySelector(`[data-tab="${currentTabTitle}"]`).classList.add('active');
        e.target.closest('.shop-categories').querySelector(`[data-tab="${currentTabTitle}"]`).querySelector(`scrollable-content`)._checkScrollability();
      }
    });
  });
}

function whySolidGoldSection() {
  const sectionEle = document.querySelectorAll('.section--gallery');
  if(!sectionEle.length) return;

  for(let i=0; i<sectionEle.length; i++){
    if(sectionEle[i] && sectionEle[i].querySelector('prev-next-buttons')){
      let sectionLeftMarginValue = sectionEle[i].querySelector('gallery-list .container');
      if(sectionLeftMarginValue){
        let style = sectionLeftMarginValue.currentStyle || window.getComputedStyle(sectionLeftMarginValue);
        let marginVal = style.marginLeft;
        sectionEle[i].querySelector('prev-next-buttons .prev-next-button--prev').style.left = marginVal;
        sectionEle[i].querySelector('prev-next-buttons .prev-next-button--next').style.right = marginVal;
      }
    }
  }
}

function updateNotifyMeForm() {
  let atcBtn = document.querySelector("[data-product-add-to-cart-button]")?.closest('.btn-qty--wrap');
  let subscriptionEle = document.querySelector('[data-widget-container]');
  let klaviyoBISFormEle = document.querySelector("[data-notify-bis-form]");
  let klaviyoBISButtonSubmit = document.querySelector("[data-notify-submit]");
  if(klaviyoBISFormEle){
    document.addEventListener('click', function(event) {
      const targetEle = event.target;
     
      //Show BIS form
      if (targetEle.hasAttribute('data-klaviyo-bis-button')) {
        event.preventDefault();
        targetEle.setAttribute('hidden','');
        if(atcBtn) atcBtn.setAttribute('hidden','');
        if(subscriptionEle) subscriptionEle.setAttribute('hidden','');
        klaviyoBISFormEle.removeAttribute('hidden');
      }

      //Submit BIS form
      if (targetEle.hasAttribute('data-notify-submit')) {
        event.preventDefault();
        const successEle = targetEle.closest(`[data-notify-bis-form]`).querySelector(`.sucess-msg`);        
        if(successEle) successEle.setAttribute('hidden','');
        const errorEle = targetEle.closest(`[data-notify-bis-form]`).querySelectorAll(`.error-col`);
        if(errorEle.length) errorEle.forEach(el=> el.setAttribute('hidden',''));
        const nameInputEle = targetEle.closest(`[data-notify-bis-form]`).querySelector(`[data-notify-name-input]`);
        let getInputName = nameInputEle.value.trim();
        const emailInputEle = targetEle.closest(`[data-notify-bis-form]`).querySelector(`[data-notify-email-input]`);
        let getInputEmail = emailInputEle.value.trim();
        let getCurrentProdId = Number(targetEle.closest('.shopify-product-form').querySelector(`input[name="product-id"]`).value);
        let getCurrentProdVariantId = Number(targetEle.closest('.shopify-product-form').querySelector(`input[name="id"]`).value);
        let btnLoaderEle = targetEle.querySelector(`.loader-button__loader`);
        if(btnLoaderEle) btnLoaderEle.setAttribute('hidden','');
        targetEle.removeAttribute('aria-busy');        
        
        if(!getInputName && !validateEmail(getInputEmail)){
          nameInputEle.nextElementSibling.removeAttribute('hidden');
          emailInputEle.nextElementSibling.removeAttribute('hidden');
          return;
        }else if(!getInputName){
          nameInputEle.nextElementSibling.removeAttribute('hidden');
          return;
        }else if(!validateEmail(getInputEmail)){
          emailInputEle.nextElementSibling.removeAttribute('hidden');
          return;
        }

        targetEle.setAttribute('aria-busy','true');
        if(btnLoaderEle) btnLoaderEle.removeAttribute('hidden');
        
        let payload = {
          a: "HTg3Ws",
          email: getInputEmail,
          name: getInputName,
          variant: getCurrentProdVariantId,
          product: getCurrentProdId,
          platform: "shopify"
        }

        // Convert payload object to URL-encoded string
        const urlEncodedData = Object.keys(payload).map(function(key) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(payload[key]);
        }).join('&');

        const sendURL = `https://a.klaviyo.com/onsite/components/back-in-stock/subscribe`;
        const dataSendToHook = async () => {
          let formDataObject = {
            method: 'POST',
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: urlEncodedData
          };
          console.log('formDataObject >>',formDataObject);
          const response = await fetch(sendURL, formDataObject);
          if (!response.ok) {
            setTimeout(() => {
              console.log('%cHTTP error! status:','color: red; font-size: 12px; font-weight: 700', response.status);
              console.log('%cSomething went wrong, please refresh the page and try again..!!','color: red; font-size: 12px; font-weight: 700');
              if(btnLoaderEle) btnLoaderEle.setAttribute('hidden','');
              targetEle.removeAttribute('aria-busy');
              return;
            },600);
          }
          const data = await response.json();
          setTimeout(() => {
            if(successEle) successEle.removeAttribute('hidden');
            if(btnLoaderEle) btnLoaderEle.setAttribute('hidden','');
            targetEle.removeAttribute('aria-busy');
            emailInputEle.value = '';
            nameInputEle.value = '';
            console.log('%cNotify form submited success >>','color: green; font-size: 12px; font-weight: 700', data);
          },600);
        }
        dataSendToHook();
      }
    });
  }
}

function validateEmail(value) {
  let mailRegularExpresion = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
  if (mailRegularExpresion) return true;    
}

function productMainReviewWidget(){
  if(!document.querySelector('.shopify-section--review')) return;
  
  //For more info:
  //https://stampedsupport.stamped.io/hc/en-us/categories/8808070973979-Developers
  function addEventListenerStamped(el, eventName, handler) { 
    if (el.addEventListener) { el.addEventListener(eventName, handler); }
    else { el.attachEvent('on' + eventName, function () { handler.call(el); }); } 
  }

  addEventListenerStamped(document, 'stamped:reviews:loaded', function(e) {
    const getRiewProdText = document.querySelectorAll('#stamped-reviews-tab .stamped-review .stamped-review-content .stamped-review-product');
    const eleToAppendText = document.querySelectorAll('#stamped-reviews-tab .stamped-review .stamped-review-header');
    if(getRiewProdText.length && eleToAppendText.length){
      for(let i=0; i<getRiewProdText.length; i++){
        if(getRiewProdText[i] && eleToAppendText[i]){
          let getInnerHtml = getRiewProdText[i].innerHTML;
          const divEle = document.createElement('div');
          divEle.classList.add('stamped-reviewd-product');
          divEle.innerHTML = `Reviewing: ${getInnerHtml}`;
          eleToAppendText[i].appendChild(divEle);
        }
      }
    }
  });
}



class ProductSubsciptionEle extends CustomHTMLElement {
  constructor() {
    super();
    this.inputOption = this.querySelectorAll(`input[name="selling_plan_select"]`);
    this.sellingPlanInput = document.querySelectorAll('form input[name="selling_plan"]');
    this.inputOption.forEach(input => input.addEventListener('change', this.subscriptionInputChanged.bind(this)));
    this.subscriptionDropdownClick();
  }

  subscriptionInputChanged(event){
    //on subscription input changed
    event.preventDefault();
    this.inputOption.forEach(el => el.closest('.rc_widget__option').classList.remove('rc-option--active'));
    event.target.closest('.rc_widget__option').classList.add('rc-option--active');
    let currentOption = event.target.value;
    if(currentOption == 'onetime'){
      if(this.sellingPlanInput.length){
        this.sellingPlanInput.forEach(ele => ele.value = '');
        if(this.querySelector(`.rc__select`)){
          this.querySelector(`.rc__select`).classList.remove('active');
        }
        if(this.querySelector(`.rc-tab-content`)){
          this.querySelector(`.rc-tab-content`).classList.remove('active');
        }
      }
    }else{
      if(this.sellingPlanInput.length){
        let selectedSeelingPlanId = this.querySelector('.styledSelect').dataset.sellingId;
        this.sellingPlanInput.forEach(ele => ele.value = Number(selectedSeelingPlanId));
        if(this.querySelector(`.rc-tab-content`)){
          this.querySelector(`.rc-tab-content`).classList.add('active');
        }
      }
    }

  }

  subscriptionDropdownClick(){
    //on style select dropdown click
    const selectDropdown = this.querySelector(`.styledSelect`);
    if(selectDropdown){
      selectDropdown.addEventListener('click',(e) => {
        e.preventDefault();
        if(e.target.closest(`.rc__select`)){
          e.target.closest(`.rc__select`).classList.toggle('active');
        }
      });
    }

    //on list item clicked
    const dropdownListItem = this.querySelectorAll(`.rc__select .options li`);
    if(dropdownListItem.length){
      dropdownListItem.forEach(list => {
        list.addEventListener('click',(li) => {
          li.preventDefault();
          let seletedListValue = li.target.getAttribute('value');
          let seletedListName = li.target.textContent;
          if(selectDropdown){
            selectDropdown.textContent = seletedListName;
            selectDropdown.dataset.sellingId = seletedListValue;
            if(this.sellingPlanInput.length){
              this.sellingPlanInput.forEach(ele => ele.value = Number(seletedListValue));
            }
            if(this.querySelector(`.rc__select`)){
              this.querySelector(`.rc__select`).classList.remove('active');
            }
          }
        });
      });
    }

    //outside click close list dropdown
    document.onclick = function(e){
      if(!e.target.classList.contains('styledSelect')){
        if(this.querySelector(`.rc__select`)){
          this.querySelector(`.rc__select`).classList.remove('active');
        }
      }
    };
  }
  
}
window.customElements.define("subscription-ele", ProductSubsciptionEle);


class klaviyoBISForm extends CustomHTMLElement {
  constructor() {
    super();
    this.klaviyoFormBtn = this.closest('.product-form')?.querySelector("[data-klaviyo-bis-button]");
    this.atcBtn = this.closest('.product-form')?.querySelector("[data-product-add-to-cart-button]")?.closest('.btn-qty--wrap');
    this.subscriptionEle = this.closest('.product-form')?.querySelector('subscription-ele');
    this.fromSubmitButton = this.querySelector("[data-notify-submit]");
    if(this.klaviyoFormBtn){
      this.klaviyoFormBtn.addEventListener('click', this.handleFormVisibility.bind(this));
    }
    if(this.fromSubmitButton){
      this.fromSubmitButton.addEventListener('click', this.handleFormSubmit.bind(this));
    }
  }
  handleFormVisibility(event){
    event.preventDefault();
    const targetEle = event.target;
    //Show BIS form
    targetEle.setAttribute('hidden','');
    if(this.atcBtn) this.atcBtn.setAttribute('hidden','');
    if(this.subscriptionEle) this.subscriptionEle.setAttribute('hidden','');
    this.removeAttribute('hidden');
  }

  handleFormSubmit(event){
    //Submit BIS form
    event.preventDefault();
    const targetEle = event.target;
    const successEle = this.querySelector(`.sucess-msg`);        
    if(successEle) successEle.setAttribute('hidden','');
    const errorEle = this.querySelectorAll(`.error-col`);
    if(errorEle.length) errorEle.forEach(el=> el.setAttribute('hidden',''));
    const nameInputEle = this.querySelector(`[data-notify-name-input]`);
    let getInputName = nameInputEle.value.trim();
    const emailInputEle = this.querySelector(`[data-notify-email-input]`);
    let getInputEmail = emailInputEle.value.trim();
    let getCurrentProdId = Number(this.closest('.shopify-product-form').querySelector(`input[name="product-id"]`).value);
    let getCurrentProdVariantId = Number(this.closest('.shopify-product-form').querySelector(`input[name="id"]`).value);
    let btnLoaderEle = this.querySelector(`.loader-button__loader`);
    if(btnLoaderEle) btnLoaderEle.setAttribute('hidden','');
    targetEle.removeAttribute('aria-busy');        
    
    if(!getInputName && !validateEmail(getInputEmail)){
      nameInputEle.nextElementSibling.removeAttribute('hidden');
      emailInputEle.nextElementSibling.removeAttribute('hidden');
      return;
    }else if(!getInputName){
      nameInputEle.nextElementSibling.removeAttribute('hidden');
      return;
    }else if(!validateEmail(getInputEmail)){
      emailInputEle.nextElementSibling.removeAttribute('hidden');
      return;
    }
  
    targetEle.setAttribute('aria-busy','true');
    if(btnLoaderEle) btnLoaderEle.removeAttribute('hidden');
    
    let payload = {
      a: "HTg3Ws",
      email: getInputEmail,
      name: getInputName,
      variant: getCurrentProdVariantId,
      product: getCurrentProdId,
      platform: "shopify"
    }
  
    // Convert payload object to URL-encoded string
    const urlEncodedData = Object.keys(payload).map(function(key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(payload[key]);
    }).join('&');
  
    const sendURL = `https://a.klaviyo.com/onsite/components/back-in-stock/subscribe`;
    const dataSendToHook = async () => {
      let formDataObject = {
        method: 'POST',
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: urlEncodedData
      };
      console.log('formDataObject >>',formDataObject);
      const response = await fetch(sendURL, formDataObject);
      if (!response.ok) {
        setTimeout(() => {
          console.log('%cHTTP error! status:','color: red; font-size: 12px; font-weight: 700', response.status);
          console.log('%cSomething went wrong, please refresh the page and try again..!!','color: red; font-size: 12px; font-weight: 700');
          if(btnLoaderEle) btnLoaderEle.setAttribute('hidden','');
          targetEle.removeAttribute('aria-busy');
          return;
        },600);
      }
      const data = await response.json();
      setTimeout(() => {
        if(successEle) successEle.removeAttribute('hidden');
        if(btnLoaderEle) btnLoaderEle.setAttribute('hidden','');
        targetEle.removeAttribute('aria-busy');
        emailInputEle.value = '';
        nameInputEle.value = '';
        console.log('%cNotify form submited success >>','color: green; font-size: 12px; font-weight: 700', data);
      },600);
    }
    dataSendToHook();
  }
}
window.customElements.define("klaviyo-bis-form", klaviyoBISForm);



// This will only render in the theme editor
if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){
      
     const pdpMainSection = event.target.closest('.main-product-section') || null;
      if(pdpMainSection){
        productDescToggle();
        productAdditionalDetailes();
        //updateNotifyMeForm();
      }
    });
     
  });
}
